import type { ComponentPropsWithoutRef } from "react";

export const SearchIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M7.18519 12.5803C10.0489 12.5803 12.3704 10.2588 12.3704 7.39515C12.3704 4.53145 10.0489 2.20996 7.18519 2.20996C4.32149 2.20996 2 4.53145 2 7.39515C2 10.2588 4.32149 12.5803 7.18519 12.5803Z"
      stroke="#E0E2EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14.8768L10.6667 11.5435"
      stroke="#E0E2EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
